import {
  DesktopDatePicker,
  LocalizationProvider,
  DatePicker as MuiDatePicker,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarIcon from 'assets/icons/calendar.svg';
import { SvgIconWrapper } from 'components/SvgIconWrapper';
import type { FC } from 'react';
import type { IDatePicker } from './DatePicker.types';

const DatePicker: FC<IDatePicker> = ({
  monthDayYearView,
  useDesktopDatePicker = true,
  ...rest
}) => {
  const commonProps: IDatePicker = {
    ...rest,
    value: rest.value ? new Date(rest.value) : rest.value,
    slots: {
      ...rest.slots,
      openPickerIcon: () => <SvgIconWrapper src={CalendarIcon} />,
    },
    sx: {
      width: '100%',
      '&': rest.error
        ? {
            svg: {
              path: {
                stroke: (theme) => theme.palette.error.main,
              },
            },
          }
        : {},
    },
    openTo: monthDayYearView ? 'month' : undefined,
    views: monthDayYearView ? ['month', 'day', 'year'] : undefined,
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {useDesktopDatePicker ? (
        <DesktopDatePicker {...commonProps} />
      ) : (
        <MuiDatePicker {...commonProps} />
      )}
    </LocalizationProvider>
  );
};

export default DatePicker;
